import {WIDGET_KEYS} from "../WidgetKeys.jsx";
import {
  EntityMainNameDefault,
  lineThroughRenderer,
  generateMultiFilterConfigFromModel,
  defaultGroupRenderer as groupRenderer, linkifyText
} from "../../utils/utils.jsx";
import {ALERT_TYPE_NAMES, ALERT_TYPES, GRID_FIELDS_TO_OPEN_EDITOR} from "../OtherKeys.jsx";
import { Reminder } from "../../../bryntum-lib/models/Reminder.jsx";
import { SWIVU_NOTIFY_COLOR_ID } from "../../configs/globalConfig.jsx";

export const REMINDER_VIEW_COLUMNS = [
  {
    id: "reminder-bell",
    type: WIDGET_KEYS.alertBellColumn,
    text: 'Read / Unread',
    field: "reminderState",
  },
  {
    id: "recipients",
    type: WIDGET_KEYS.reminderRecipientsColumn,
    editor: false,
    cellCls: "swivu-recipients-cell flex gap-[0.5em]",
  },
  {
    id: "reminder-alert-type",
    text: "Notify Type",
    filterType: "string",
    field: "alertTag",
    flex: 1,
    editor: false,
    groupRenderer,
    renderer({ value, record }) {
      return {
        children: [
          {
            tag: "span",
            class: `${SWIVU_NOTIFY_COLOR_ID[record.alertType] || ALERT_TYPE_NAMES[record.alertType]} tag-cell`,
            text: value,
          }
        ]
      }
    }
  },
  {
    id: "reminder-entity",
    text: "Entity",
    filterType: "string",
    field: "asEntityType",
    flex: 1,
    editor: false,
    renderer({ value, record }) {
      if (record.alertType === ALERT_TYPES.AsyncTask) {
        return "Async Tasks"
      }
      return value;
    },
    groupRenderer(e) {
      const firstRecord = e.groupRecords?.[0];
      e.groupRowFor = firstRecord?.alertType === ALERT_TYPES.AsyncTask ? "Async Tasks" : e.groupRowFor;
      return groupRenderer(e);
    },
  },
  {
    id: "reminder-name",
    text: "Entity Name",
    filterType: "string",
    // Todo: use EntityMainName Column
    type: WIDGET_KEYS.swivuSortColumn,
    field: GRID_FIELDS_TO_OPEN_EDITOR.ENTITY_NAME,
    flex: 1,
    editor: false,
    renderer: ({ value, record })=> EntityMainNameDefault(lineThroughRenderer(value, record.archived)),
    groupRenderer
  },
  {
    id: "reminder-description",
    text: "Notify Subject",
    type: WIDGET_KEYS.swivuSortColumn,
    field: "description",
    flex: 1,
    cellCls: "!overflow-hidden",
    renderer: ({ record, value }) => linkifyText(lineThroughRenderer(value, record.archived)),
    groupRenderer,
  },
  {
    id: "reminder-alert-date",
    type: "date",
    field: "_alertDate",
    text: "Notify Date",
    flex: 1,
    editor: {
      keepTime: true,
      required: true,
    },
    groupRenderer,
  },
  {
    id: "reminder-alert-time",
    type: "time",
    // filterType is not really required at the moment, however to make this column future-proof we
    // need to explicitly provide our special filter type
    filterType: "_swivu_time",
    field: "_alertTime",
    text: "Notify Time",
    flex: 1,
    editor: {
      keepDate: true,
      required: true,
    },
    groupRenderer,
  },
  {
    id: "reminder-remaining",
    field: "remaining",
    text: "Remaining",
    type: "number",
    flex: 1,
    editor: false,
    hidden: true,
    groupRenderer,
  }
]

export const REMINDER_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(Reminder),
  reminderRecipientValues: { type: '_swivu_settings' },
  alertTypeName: { type: "string" },
  [GRID_FIELDS_TO_OPEN_EDITOR.ENTITY_NAME]: { type: "string" },
  asEntityType: { type: "string" },
  entityName: { type: "string" },
  _alertTime: { type: "_swivu_time" },
  repeatCount: { type: "number" },
}
